const ARCHIVE_STRATEGY = "strategy::archive";
const ARCHIVE_STRATEGY_FAILURE = "strategy::archive::failure";
const ARCHIVE_STRATEGY_SUCCESS = "strategy::archive::success";
const EDIT_STRATEGY = "strategy::edit";
const EDIT_STRATEGY_FAILURE = "strategy::edit::failure";
const EDIT_STRATEGY_SUCCESS = "strategy::edit::success";
const LOAD_STRATEGIES = "strategy::load-all::success";
const LOAD_STRATEGIES_FAILURE = "strategy::load-all::failure";
const NEW_STRATEGY = "strategy::new";
const NEW_STRATEGY_FAILURE = "strategy::new::failure";
const NEW_STRATEGY_SUCCESS = "strategy::new::success";
const UPDATE_STRATEGY = "strategy::update";

function updateStrategyStoreAction(payload) {
  return {
    payload,
    type: UPDATE_STRATEGY,
  };
}

function archiveStrategyAction(strategyId, archiveStatus, successMessage = "") {
  return {
    payload: {
      successMessage,
      serviceArgs: [strategyId, archiveStatus],
    },
    type: ARCHIVE_STRATEGY,
  };
}

function newStrategyAction(strategy, successMessage = "") {
  return {
    payload: {
      successMessage,
      serviceArgs: [strategy],
    },
    type: NEW_STRATEGY,
  };
}

function editStrategyAction(id, strategy, successMessage = "") {
  return {
    payload: {
      successMessage,
      serviceArgs: [id, strategy],
    },
    type: EDIT_STRATEGY,
  };
}

export {
  ARCHIVE_STRATEGY,
  ARCHIVE_STRATEGY_FAILURE,
  ARCHIVE_STRATEGY_SUCCESS,
  EDIT_STRATEGY,
  EDIT_STRATEGY_FAILURE,
  EDIT_STRATEGY_SUCCESS,
  editStrategyAction,
  LOAD_STRATEGIES,
  LOAD_STRATEGIES_FAILURE,
  NEW_STRATEGY,
  NEW_STRATEGY_FAILURE,
  NEW_STRATEGY_SUCCESS,
  newStrategyAction,
  UPDATE_STRATEGY,
  updateStrategyStoreAction,
  archiveStrategyAction,
};
